export const EMAIL_DOMAIN = process.env.REACT_APP_EMAIL_DOMAIN;

export const NO_SENIORITY = 'n/a';
export const ZOHO_PEOPLE_UPDATE_DISABLED_INFO = 'Temporary unavailable due to HRIS system issues';

export const REFER_A_FRIEND_LINK =
  'https://launchpod.agileengine.com/refer-a-friend?utm_source=Inbound&utm_medium=Internal+Referral+(Rocky)&utm_campaign=candidatereferral_rocky&utm_term=&utm_technical-flow=';
